import { CheckCircle, MessageSquare, Phone, Lightbulb } from "lucide-react";
import Typography from "../ui/Typography";

interface ResponseProps {
  onReset: () => void;
}

const Response = ({ onReset }: ResponseProps) => {
  const handleBackToHome = () => {
    onReset();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="flex items-center justify-center px-4 py-20">
      <div className="text-center max-w-lg">
        <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
        <Typography.Title className="mb-2">Message Sent!</Typography.Title>
        <Typography.Body className="mb-10">
          Thanks for reaching out. We'll get back to you within 24 hours.
        </Typography.Body>

        <div className="text-left space-y-6 mb-10">
          <Typography.Subtitle className="text-center mb-6">What happens next?</Typography.Subtitle>
          <div className="flex items-start gap-4">
            <div className="shrink-0 w-8 h-8 rounded-full bg-indigo-500/20 border border-indigo-500/30 flex items-center justify-center">
              <MessageSquare className="w-4 h-4 text-indigo-400" />
            </div>
            <div>
              <Typography.Body className="text-white">We review your message</Typography.Body>
              <Typography.Caption>Our team reads every submission personally.</Typography.Caption>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="shrink-0 w-8 h-8 rounded-full bg-green-500/20 border border-green-500/30 flex items-center justify-center">
              <Phone className="w-4 h-4 text-green-400" />
            </div>
            <div>
              <Typography.Body className="text-white">We schedule a call</Typography.Body>
              <Typography.Caption>A free 30-minute consultation to understand your needs.</Typography.Caption>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <div className="shrink-0 w-8 h-8 rounded-full bg-purple-500/20 border border-purple-500/30 flex items-center justify-center">
              <Lightbulb className="w-4 h-4 text-purple-400" />
            </div>
            <div>
              <Typography.Body className="text-white">We propose a solution</Typography.Body>
              <Typography.Caption>A tailored plan with clear scope, timeline, and pricing.</Typography.Caption>
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={handleBackToHome}
          className="text-btn text-gray-400 hover:text-white transition-colors cursor-pointer focus-visible:ring-2 focus-visible:ring-indigo-500/50 focus-visible:outline-none rounded-md px-4 py-2"
        >
          Back to Home
        </button>
      </div>
    </section>
  );
};

export default Response;
